import axios from 'axios';

const getNotificacoesUserList = params => axios.get('user/notificacao/list', { params });

const getNotificacoesCompradorList = params => axios.get('comprador/notificacoes/list', { params });

const saveCompradorNotificacao = (notificacao) => {
  if (notificacao.id) {
    return axios.put(`comprador/notificacoes/${notificacao.id}`, notificacao);
  }
  return axios.post('comprador/notificacoes', notificacao);
};

const saveUserNotificacao = (notificacao) => {
  if (notificacao.id) {
    return axios.put(`user/notificacao/${notificacao.id}`, notificacao);
  }
  return axios.post('user/notificacao', notificacao);
};

export default {
  getNotificacoesUserList,
  saveUserNotificacao,
  getNotificacoesCompradorList,
  saveCompradorNotificacao,
};
